import {GetStaticPaths, GetStaticPropsContext} from 'next';
import React from 'react';
import {dehydrate, QueryClient} from 'react-query';

import {disallowSlug, FOUR_HOURS, RENDER_MODES} from '@udemy/nextjs-core';

import {SpectaQLRenderer} from 'src/components/spectaql-renderer/spectaql-renderer';
import {getCompactTranslations} from 'src/lib-server/locale.server';
import {getStaticAppContext} from 'src/pages/api/context.api';
import {AppContextData} from 'src/types/page-props';

import html from './spectaql/index.html';
import {DevHubPageFeature} from '../../../features/dev-hub';
import {getDevHubLayout} from '../../../layouts/devhub-layout';

export const getStaticPaths: GetStaticPaths = () => {
    return {
        paths: [],
        fallback: 'blocking',
    };
};

export const getStaticProps = disallowSlug(async (context: GetStaticPropsContext) => {
    const client = new QueryClient();

    const locale = context.locale as string;
    const translations = await getCompactTranslations(locale);

    // Resolve appContext
    const [staticData] = await Promise.all([getStaticAppContext({locale})]);

    const appContext: AppContextData = Object.assign({}, staticData);

    return {
        props: {
            appContext,
            client: dehydrate(client),
            pageKey: 'dev_hub',
            locale: context.locale,
            renderMode: RENDER_MODES.ISR,
            translations,
        },
        revalidate: FOUR_HOURS,
    };
});

const IndexPage = () => {
    return (
        <DevHubPageFeature>
            <SpectaQLRenderer html={html} />
        </DevHubPageFeature>
    );
};

IndexPage.getLayout = getDevHubLayout;

export default IndexPage;
